import React, { Fragment } from "react";
// import debug from "../debug";

import styles from "./SvgDeadEnd.module.scss";

// const log = debug("SvgConnector");

interface Props {
    fromX: number;
    fromY: number;
    toX: number;
    toY: number;
    fillKey: string;
    text: string;
}

const SvgDeadEnd: React.FC<Props> = function ({ fromX, fromY, toX, toY, fillKey, text, ...props }: Props) {
    const fill = `url('#${fillKey}')`;

    //
    // svg path editor - good for debugging
    // https://yqnn.github.io/svg-path-editor/
    //
    const r = toX - fromX;
    const midX = fromX + (toX - fromX) * 0.5;
    const midY = fromY + r;
    return (
        <Fragment {...props}>
            <path
                d={`M ${fromX} ${fromY} A ${r} ${r} 0 0 1 ${toX} ${fromY + r} L ${toX} ${toY} L ${fromX} ${toY} Z`}
                stroke={fill}
                strokeWidth={2}
                fill={fill}
            />
            <text className={styles.text} x={midX} y={midY} textAnchor="middle">
                ↓ {text}
            </text>
        </Fragment>
    );
};

export default SvgDeadEnd;
